import { Component } from "react";
import { Button } from "@/components/ui/button";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Unhandled error detected:", error, info);
    if (typeof this.props.onError === "function") {
      this.props.onError(error, info);
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
          <div className="max-w-md w-full bg-white rounded-2xl border shadow-sm p-8 text-center space-y-4">
            <div className="text-4xl" role="img" aria-label="Dizzy face">
              😵‍💫
            </div>
            <h1 className="text-2xl font-semibold text-gray-900">
              Something broke
            </h1>
            <p className="text-sm text-gray-600">
              An unexpected error occurred. Please try reloading this section.
              If the problem continues, contact{" "}
              <a
                href="mailto:support@vouchee.app"
                className="text-green-600 underline"
              >
                support@vouchee.app
              </a>
              .
            </p>
            <Button onClick={this.handleRetry} className="w-full">
              Try again
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
